import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  { name: 'impoundTypeId', label: 'Type', levelType: AutoLockFormsLevelType.FIELD },
  { name: 'monthlyAmount', label: 'Monthly Amount', levelType: AutoLockFormsLevelType.FIELD },
];

export const supplementalInsurancesForm = {
  name: FormNames.SUPPLEMENTAL_INSURANCES,
  label: 'Supplemental Insurances',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
